import { VehicleDetailsDocumentOutput } from './vehicle-details-document-output.model';


export class VehicleDocumentDetailsSelectByIdOutput implements IVehicleDocumentDetailsSelectByIdOutput {
    status!: number;
    message!: string;
    data!: VehicleDetailsDocumentOutput;

    constructor(data?: IVehicleDocumentDetailsSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleDetailsDocumentOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleDocumentDetailsSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDocumentDetailsSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleDocumentDetailsSelectByIdOutput {
    status: number;
    message: string;
    data: VehicleDetailsDocumentOutput;
}

